import { Country } from 'countries-and-timezones';
import Box from '@mui/material/Box';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
// import { CheckboxWithLabel } from 'components';

export type SortField = 'overlap' | 'hdi' | 'countryName';
export type SortDirection = 'asc' | 'desc';

export const sortingOptions = [
  { label: 'Overlap: Low to High', value: 'overlap-asc' },
  { label: 'Overlap: High to Low', value: 'overlap-desc' },
  { label: 'HDI: Low to High', value: 'hdi-asc' },
  { label: 'HDI: High to Low', value: 'hdi-desc' },
  { label: 'Country: A - Z', value: 'countryName-asc' },
  { label: 'Country: Z - A', value: 'countryName-desc' },
];

export const FilteringWithSortPanel = ({
  setSorting,
  sortField,
  sortDirection,
  // onlyShowRecordsWithLowHDI,
  // setOnlyShowRecordsWithLowHDI,
  // onlyShowRecordsWithHiringData,
  // setOnlyShowRecordsWithHiringData,
  searchValues,
  setSearchValues,
  searchCountriesOptions,
}: {
  setSorting: (sorting: {
    sortField: SortField;
    sortDirection: SortDirection;
  }) => void;
  sortField: SortField;
  sortDirection: SortDirection;
  onlyShowRecordsWithLowHDI: boolean;
  setOnlyShowRecordsWithLowHDI: (arg: boolean) => void;
  onlyShowRecordsWithHiringData: boolean;
  setOnlyShowRecordsWithHiringData: (arg: boolean) => void;
  searchValues: Country[];
  setSearchValues: (value: Country[]) => void;
  searchCountriesOptions: Country[];
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        gap: '20px',
        mb: '18px',
      }}
    >
      <Box flex="1">
        <Typography
          variant="textMedium"
          color="text.secondary"
          mb={5}
          fontWeight={500}
          display="block"
        >
          Select countries to remove them from results
        </Typography>
        <Autocomplete
          sx={{
            minWidth: '230px',
            '.MuiChip-root': {
              height: '28px',
            },
          }}
          ListboxProps={{
            style: {
              maxHeight: '300px',
            },
          }}
          multiple
          value={searchValues}
          onChange={(event, value) => setSearchValues(value)}
          getOptionLabel={(option) => `${option.name} (${option.id})`}
          options={searchCountriesOptions}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          disableCloseOnSelect
          filterSelectedOptions
          limitTags={3}
          filterOptions={(options, { inputValue }) =>
            options.filter(({ name, id }) =>
              inputValue
                .trim()
                .toLowerCase()
                .split(' ')
                .every((word) =>
                  `${name} ${id}`.trim().toLowerCase().includes(word)
                )
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select countries to remove them from results"
            />
          )}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginLeft: 'auto',
          flexDirection: 'column',
        }}
      >
        {/*<Box*/}
        {/*  sx={{*/}
        {/*    display: 'flex',*/}
        {/*    flexWrap: 'wrap',*/}
        {/*    mb: '12px',*/}
        {/*  }}*/}
        {/*>*/}
        {/*<CheckboxWithLabel*/}
        {/*  label="Only show countries with low HDI"*/}
        {/*  onClick={() =>*/}
        {/*    setOnlyShowRecordsWithLowHDI(!onlyShowRecordsWithLowHDI)*/}
        {/*  }*/}
        {/*/>*/}
        {/*<CheckboxWithLabel*/}
        {/*  label="Only show countries with hiring guides"*/}
        {/*  onClick={() =>*/}
        {/*    setOnlyShowRecordsWithHiringData(!onlyShowRecordsWithHiringData)*/}
        {/*  }*/}
        {/*/>*/}
        {/*</Box>*/}

        <Typography
          variant="textMedium"
          color="text.secondary"
          mb={5}
          fontWeight={500}
          sx={{
            ml: 'auto',
          }}
        >
          Sort by
        </Typography>

        <Autocomplete
          sx={{
            minWidth: '230px',
          }}
          ListboxProps={{
            style: {
              maxHeight: '300px',
            },
          }}
          value={sortingOptions.find(
            ({ value }) => value === `${sortField}-${sortDirection}`
          )}
          disableClearable
          onChange={(event, { value }) => {
            const [field, direction] = value.split('-');
            setSorting({
              sortField: field as SortField,
              sortDirection: direction as SortDirection,
            });
          }}
          getOptionLabel={(option) => option.label}
          options={sortingOptions}
          renderInput={(params) => <TextField {...params} />}
        />
      </Box>
    </Box>
  );
};

export * from './useFilteringWithSortState';
